import { useQuery } from "@tanstack/react-query";
import { useEvent } from "../context/EventProvider";
import { fetchCoworkers, type Coworker } from "./coworkers";
import { useParticipation } from "./useParticipation";

/**
 * LES COLLABORATEURS DU PORTEUR, À PROPOSER COMME ACCOMPAGNANTS.
 *
 * ⚠️ DEMANDÉS SEULEMENT QUAND L'ORGANISATEUR L'A ALLUMÉ, comme la V1 n'ouvrait sa liste
 * que sous `FO_MEETING_COMPANIONS_ASSOCIATES_IS_ACTIVE` : sinon, une requête de plus sur
 * l'étape de chaque événement, pour une liste qui ne s'afficherait pas.
 *
 * ⚠️ `failed` EST DISTINCT DE « AUCUN » : une lecture en échec ne doit pas dire au
 * porteur qu'il n'a pas de collaborateurs.
 */
export function useCoworkers(active: boolean): {
  coworkers: ReadonlyArray<Coworker>;
  loading: boolean;
  failed: boolean;
} {
  const event = useEvent();
  const { me } = useParticipation();

  const q = useQuery({
    queryKey: ["collaborateurs", event?.domainId, event?.eventId, me?.id],
    queryFn: ({ signal }) =>
      fetchCoworkers(event!.domainId, event!.eventId, me!.id, signal),
    enabled: active && !!event && typeof me?.id === "number",
    /* Relue après chaque choix (l'écran invalide cette clé) : « déjà inscrit » change. */
    staleTime: Infinity,
    retry: false,
  });

  return {
    coworkers: q.data ?? [],
    loading: active && q.isLoading,
    failed: active && q.isError,
  };
}
